import { frontendURL } from '../../../helper/URLHelper';
import CatalogIndex from './pages/CatalogIndex.vue';
import CatalogDetail from './pages/CatalogDetail.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/catalog'),
    name: 'catalog_index',
    component: CatalogIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/catalog/:productId'),
    name: 'catalog_detail',
    component: CatalogDetail,
    meta: commonMeta,
  },
];
